/* tslint:disable */
/* eslint-disable */
/**
 * Product Storage API
 * ### Poizon API Documentation  **Официальная документация Poizon API.**  #### 📚 Ресурсы  - [Официальный GitHub SDK](https://github.com/Poizon-API/public-api)  - [OpenApi JSON](https://poizon-api.com/api/product-storage/api-json)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PriceDto
 */
export interface PriceDto {
    /**
     * Minimum price
     * @type {number}
     * @memberof PriceDto
     */
    'minPrice': number;
    /**
     * Maximum price
     * @type {number}
     * @memberof PriceDto
     */
    'maxPrice': number;
    /**
     * Currency
     * @type {string}
     * @memberof PriceDto
     */
    'currency': PriceDtoCurrencyEnum;
}

export const PriceDtoCurrencyEnum = {
    Rub: 'RUB',
    Cny: 'CNY',
    Eur: 'EUR',
    Usd: 'USD'
} as const;

export type PriceDtoCurrencyEnum = typeof PriceDtoCurrencyEnum[keyof typeof PriceDtoCurrencyEnum];


